<template>
  <div class="main-centent" :class="theme == 1 ? 'white' : 'black'">
    <!-- <p class="header">
      尊敬的用户：为保障您的投资权益，提供更好的服务，按证监会《证券期货投资者适当性管理办法》要求，需要您提供真实身份信息并完成风险评测，感谢您的理解
    </p>
    <div class="ipt">
      <p>姓名</p>
      <input v-model="text" placeholder="请输入姓名" @input="ipt" />
    </div>
  
    <div class="ipt">
      <p>身份证</p>
      <input
        v-model="number"
        maxlength="18"
        placeholder="请输入身份证编号"
        @input="ipt"
      />
    </div>
    <div class="ipt" v-if="phone != ''">
      <p>手机号</p>
      <span>{{ phone }}</span>

    </div>

    <button v-show="show">提交</button>
    <button
      @click="subClick"
      style="background: rgba(244, 67, 54, 1)"
      v-show="show1"
    >
      提交
    </button>
    <p class="footer">
      特别说明：以上信息仅作监管备用，平台会对数据进行加密，不会泄漏给第三方，请放心填写。
    </p> -->
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);
import { Field, Button } from "vant";
import api from "@/api/mall";
import {
  connectWebViewJavascriptBridge,
  getBrowserUserAgent,
} from "@/utils/utility";
var userAgent = getBrowserUserAgent();
var dsBridge = require("dsbridge");
var dsBridge = require("dsbridge");
var picHost = process.env.VUE_APP_PIC_BASE_URL;
export default {
  components: { [Field.name]: Field, [Button.name]: Button },
  data() {
    return {
      number: "",
      text: "",
      phone: "",
      show: true,
      show1: false,
      routeType: 0,
      theme: 1,
    };
  },
  mounted() {
    if (userAgent.android) {
      var that = this;
      this.$bridge.registermethod("changeTheme", function(responseData) {
        responseData = JSON.parse(responseData);
        that.theme = responseData;
        sessionStorage.setItem("theme", responseData);
      });
    } else {
      connectWebViewJavascriptBridge((bridge) => {
        window.WebViewJavascriptBridge.registerHandler("changeTheme", function(
          responseData
        ) {
          responseData = JSON.parse(responseData);
          that.theme = responseData;
          sessionStorage.setItem("theme", responseData);
        });
      });
    }
  },
  created() {
    if (sessionStorage.getItem("theme") == 2) {
      this.theme = 2;
    } else if (this.$route.query.theme == 2) {
      this.theme = 2;
    } else {
      this.theme = 1;
    }
    this.doPayRequest();
    
    if (this.$route.query.routeType) {
      this.routeType = this.$route.query.routeType;
    }
  },
  activated() {
    this.theme = sessionStorage.getItem("theme");
  },
  methods: {
    ipt() {
      var that = this;
      var reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
      if (that.text != "" && reg.test(that.number)) {
        that.show = false;
        // console.log(this.text, this.phone, this.number)
        that.show1 = true;
      } else {
        that.show = true;
        that.show1 = false;
      }
    },
    subClick() {},
    doPayRequest() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });

      api.getUserInfo({}).then((res) => {
        if (res.code == 200) {
          if (res.data.isAuth == 1) {
            if (this.routeType == 1) {
              if (userAgent.android) {
                this.$bridge.callmethod("closeContainer");
              } else {
                window.WebViewJavascriptBridge.callHandler(
                  "closeContainer",
                  function(responseData) {}
                );
              }
            }
          }else{
            this.getPhone();
          }
        }
      });
    },
    getPhone() {
      let params = {
        params: window.location.href,
        deviceType: 2,
      };
      api.getAccountRegister(params).then((res) => {
        if (res.code == 200) {
          window.location.replace(res.data.url);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.white {
  background: #fff;
  color: #333;
  .header {
    color: rgba(102, 102, 102, 1);
  }
  .footer {
    color: #999;
  }
}
.black {
  // color: #f0f1f4;
  background: #12161f;

  .header {
    color: #475166;
  }
  .footer {
    color: #69738c;
  }

  .ipt {
    background: #12161f;
    color: #f0f1f4;
    border-bottom: 0.02rem solid #242b3b;
    input {
      width: 4rem;
      background: #12161f;
      border: 0;
    }
  }
  input::-webkit-input-placeholder {
    color: #a7b0c4;
  }
  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #a7b0c4;
  }
  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #a7b0c4;
  }
  input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #a7b0c4;
  }
}
.van-field__control:disabled {
  color: #333;
}
.van-cell {
  color: #333;
  /* height: 1.04rem; */
  padding: 12px 0 12px 16px;
}
.ipt {
  height: 1.04rem;
  background: #fff;
  border-bottom: 0.02rem solid #eeeff4;
  display: flex;
  padding-left: 0.32rem;
  align-items: center;
}
.ipt p {
  width: 80px;
}
.ipt input {
  width: 4rem;
  // background: #fff;
  border: 0;
}
button {
  width: 6.86rem;
  height: 0.82rem;
  font-size: 0.34rem;
  margin: 0.68rem 0 0.48rem 0.32rem;
  color: #fff;
  background: rgba(244, 67, 54, 0.6);
  display: flex;
  border: 0;
  justify-content: center;
  align-items: center;
}
.header {
  padding: 0.44rem 0.64rem 0.46rem 0.32rem;
  font-size: 0.26rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;

  line-height: 0.36rem;
}
.footer {
  padding: 0 0.64rem 0 0.32rem;
  font-size: 0.26rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // color: #999999;
  line-height: 0.36rem;
}
.main-centent {
  height: 100%;
  // background: #eeeff4;
}
</style>
